import axiosAuth from '../../../shared/configs/axios-auth'

const getDefaultState = () => {
    return {
        chat: [],
        chatId: null,
        lastMessage: null,
        connection: null
    }
}

const state = getDefaultState()

const getters = {
    chat: state => {
        return state.chat
    },
    chatId: state => {
        return state.chatId
    },
    lastMessage: state => {
        return state.lastMessage
    },
    connection: state => {
        return state.connection
    },

}

const mutations = {
    chat (state, payload) {
        state.chat = payload
    },
    chatId (state, payload) {
        state.chatId = payload
    },
    lastMessage (state, payload) {
        state.lastMessage = payload
    },
    connection (state, payload) {
        state.connection = payload
    },

}

const actions = {
    getChats: ({commit}, payload) =>{
        commit('updating', true)
        axiosAuth.get('/chats/' + payload._id)
        .then(
            res => {
                commit('updating', false)
                commit('chat', res.data)
            }
          )
          .catch(
            error => {
              console.log(error.response)
              commit('updating', false)
            }
          )
    },
  
}

export default {
    state,
    getters,
    mutations,
    actions
}